import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_forge_hub_classic = _resolveComponent("forge-hub-classic")!
  const _component_forge_hub = _resolveComponent("forge-hub")!

  return (_ctx.classic)
    ? (_openBlock(), _createBlock(_component_forge_hub_classic, {
        key: 0,
        onLayout: _ctx.setLayout
      }, null, 8, ["onLayout"]))
    : (_openBlock(), _createBlock(_component_forge_hub, {
        key: 1,
        onLayout: _ctx.setLayout
      }, null, 8, ["onLayout"]))
}